var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "qr-code-pay-div",
      staticStyle: {
        width: "100%",
        height: "100%",
        "background-color": "#f4f4f5"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "man-container",
          staticStyle: { "overflow-y": "auto", height: "calc(100% - 60px)" }
        },
        [
          _c(
            "mobile-card",
            { staticStyle: { "font-size": "14px" } },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticClass: "charge-card-title" }, [
                  _vm._v("人员信息")
                ])
              ]),
              _c("template", { slot: "content" }, [
                _c(
                  "div",
                  {
                    staticClass: "flex-form-info",
                    staticStyle: { height: "auto" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "left",
                        staticStyle: { "line-height": "28px" }
                      },
                      [_vm._v("用户编号：")]
                    ),
                    _c("div", { staticClass: "right" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            padding: "0px",
                            margin: "0px",
                            height: "100%",
                            "line-height": "28px",
                            "padding-right": "5px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.userInfo.userCode))]
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "flex-form-info",
                    staticStyle: { height: "auto" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "left",
                        staticStyle: { "line-height": "28px" }
                      },
                      [_vm._v("用户姓名：")]
                    ),
                    _c("div", { staticClass: "right" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            padding: "0px",
                            margin: "0px",
                            height: "100%",
                            "line-height": "28px",
                            "padding-right": "5px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.userInfo.userName))]
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "flex-form-info",
                    staticStyle: { height: "auto" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "left",
                        staticStyle: { "line-height": "28px" }
                      },
                      [_vm._v("所属部门：")]
                    ),
                    _c("div", { staticClass: "right" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            padding: "0px",
                            margin: "0px",
                            height: "100%",
                            "line-height": "28px",
                            "padding-right": "5px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.userInfo.deptNames
                                ? _vm.userInfo.deptNames
                                : "--"
                            )
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "flex-form-info",
                    staticStyle: { height: "auto" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "left",
                        staticStyle: { "line-height": "28px" }
                      },
                      [_vm._v("证件号码：")]
                    ),
                    _c("div", { staticClass: "right" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            padding: "0px",
                            margin: "0px",
                            height: "100%",
                            "line-height": "28px",
                            "padding-right": "5px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm._f("normalMask")(_vm.userInfo.idNum))
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "flex-form-info",
                    staticStyle: { height: "auto" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "left",
                        staticStyle: { "line-height": "28px" }
                      },
                      [_vm._v("手机号码：")]
                    ),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c("van-field", {
                          staticStyle: {
                            padding: "0px",
                            margin: "0px",
                            height: "100%",
                            "line-height": "28px",
                            "padding-right": "5px"
                          },
                          attrs: {
                            "input-align": "right",
                            "label-align": "left",
                            size: "14px",
                            placeholder: "请输入手机号码",
                            "right-icon": "edit"
                          },
                          model: {
                            value: _vm.userInfo.tele,
                            callback: function($$v) {
                              _vm.$set(_vm.userInfo, "tele", $$v)
                            },
                            expression: "userInfo.tele"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "flex-form-info",
                    staticStyle: { height: "auto" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "left",
                        staticStyle: { "line-height": "28px" }
                      },
                      [_vm._v("电子邮箱：")]
                    ),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c("van-field", {
                          staticStyle: {
                            padding: "0px",
                            margin: "0px",
                            height: "100%",
                            "line-height": "28px",
                            "padding-right": "5px"
                          },
                          attrs: {
                            "input-align": "right",
                            "label-align": "left",
                            size: "14px",
                            placeholder: "请输入电子邮箱",
                            "right-icon": "edit"
                          },
                          model: {
                            value: _vm.userInfo.email,
                            callback: function($$v) {
                              _vm.$set(_vm.userInfo, "email", $$v)
                            },
                            expression: "userInfo.email"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            2
          ),
          _c(
            "mobile-card",
            { staticStyle: { "font-size": "14px" } },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticClass: "charge-card-title" }, [
                  _vm._v("银行卡信息")
                ])
              ]),
              _c("template", { slot: "content" }, [
                _c(
                  "div",
                  {
                    staticClass: "flex-form-info",
                    staticStyle: { height: "auto" }
                  },
                  [
                    _c("div", { staticClass: "left" }, [_vm._v("户名：")]),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c("van-field", {
                          attrs: {
                            "input-align": "right",
                            "label-align": "left",
                            size: "14px",
                            placeholder: "请输入户名",
                            readonly: ""
                          },
                          model: {
                            value: _vm.userInfo.bankAccountName,
                            callback: function($$v) {
                              _vm.$set(_vm.userInfo, "bankAccountName", $$v)
                            },
                            expression: "userInfo.bankAccountName"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "flex-form-info",
                    staticStyle: { height: "auto" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "left",
                        staticStyle: { "line-height": "28px", width: "56px" }
                      },
                      [_vm._v("卡号：")]
                    ),
                    _c(
                      "div",
                      { staticClass: "right", staticStyle: { width: "320px" } },
                      [
                        _c(
                          "van-form",
                          { ref: "bankForm", attrs: { rules: "rules" } },
                          [
                            _c("van-field", {
                              attrs: {
                                "input-align": "right",
                                "label-align": "left",
                                maxlength: "19",
                                size: "14px",
                                placeholder: "请输入银行卡号",
                                rules: [
                                  {
                                    required: true,
                                    message: "银行账号不能为空",
                                    trigger: "onBlur"
                                  }
                                ],
                                formatter: _vm.formatter,
                                "right-icon": "edit"
                              },
                              model: {
                                value: _vm.userInfo.bankCardNumber,
                                callback: function($$v) {
                                  _vm.$set(_vm.userInfo, "bankCardNumber", $$v)
                                },
                                expression: "userInfo.bankCardNumber"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "0px 20px 0px 20px",
                      color: "red",
                      "text-align": "right"
                    }
                  },
                  [_vm._v(" 注意：只能输入一类卡银行信息 ")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "flex-form-info",
                    staticStyle: { height: "auto" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "left",
                        staticStyle: { "line-height": "43px" }
                      },
                      [_vm._v("经办行：")]
                    ),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c("van-field", {
                          staticStyle: { height: "35px" },
                          attrs: {
                            readonly: "",
                            clickable: "",
                            placeholder: "请选择经办行",
                            rules: [
                              {
                                required: true,
                                message: "必选",
                                trigger: "onChange"
                              }
                            ],
                            "right-icon": _vm.manageBankIcon
                          },
                          on: {
                            click: function($event) {
                              _vm.showManageBank = true
                            }
                          },
                          model: {
                            value: _vm.manageBankName,
                            callback: function($$v) {
                              _vm.manageBankName = $$v
                            },
                            expression: "manageBankName"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "flex-form-info",
                    staticStyle: { height: "auto" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "left",
                        staticStyle: { "line-height": "43px" }
                      },
                      [_vm._v("开户行：")]
                    ),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c("van-field", {
                          staticStyle: { height: "35px" },
                          attrs: {
                            readonly: "",
                            clickable: "",
                            placeholder: "请选择开户行",
                            rules: [
                              {
                                required: true,
                                message: "必选",
                                trigger: "onChange"
                              }
                            ],
                            "right-icon": _vm.openBankIcon
                          },
                          on: {
                            click: function($event) {
                              _vm.showOpenBank = true
                            }
                          },
                          model: {
                            value: _vm.openBankName,
                            callback: function($$v) {
                              _vm.openBankName = $$v
                            },
                            expression: "openBankName"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "0px 20px 0px 20px",
                      color: "red",
                      "text-align": "right",
                      "font-size": "13px"
                    }
                  },
                  [
                    _vm._v(
                      " 只要经办行是中行，默认选择开户行是黄石东路支行就可以 "
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "flex-form-info",
                    staticStyle: { height: "auto" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "left",
                        staticStyle: { "line-height": "43px" }
                      },
                      [_vm._v("附件：")]
                    ),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c("van-uploader", {
                          attrs: {
                            "after-read": _vm.onRead,
                            accept: ".jpg,.jepg,.png,.pdf,.zip,.rar,.7z",
                            "max-count": 6,
                            "max-size": "500 * 1024"
                          },
                          on: { oversize: _vm.onOversize, delete: _vm.delImg },
                          model: {
                            value: _vm.fileList,
                            callback: function($$v) {
                              _vm.fileList = $$v
                            },
                            expression: "fileList"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "0px 20px 0px 20px",
                      color: "#ff0000",
                      "text-align": "right",
                      "font-size": "13px"
                    }
                  },
                  [_vm._v(" " + _vm._s(this.bank_info_note) + " ")]
                )
              ])
            ],
            2
          ),
          _c(
            "mobile-card",
            { staticStyle: { "font-size": "14px" } },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticClass: "charge-card-title" }, [
                  _vm._v("票据信息")
                ])
              ]),
              _c("template", { slot: "content" }, [
                _c(
                  "div",
                  {
                    staticClass: "flex-form-info",
                    staticStyle: { height: "auto" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "left",
                        staticStyle: { "line-height": "28px" }
                      },
                      [_vm._v("票据抬头：")]
                    ),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c("van-field", {
                          staticStyle: {
                            padding: "0px",
                            margin: "0px",
                            height: "100%",
                            "line-height": "28px",
                            "padding-right": "5px"
                          },
                          attrs: {
                            "input-align": "right",
                            "label-align": "left",
                            size: "14px",
                            placeholder: "请输入票据抬头",
                            "right-icon": "edit"
                          },
                          model: {
                            value: _vm.userInfo.ticketTitle,
                            callback: function($$v) {
                              _vm.$set(_vm.userInfo, "ticketTitle", $$v)
                            },
                            expression: "userInfo.ticketTitle"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "flex-form-info",
                    staticStyle: { height: "auto" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "left",
                        staticStyle: { "line-height": "28px" }
                      },
                      [_vm._v("票据税号：")]
                    ),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c("van-field", {
                          staticStyle: {
                            padding: "0px",
                            margin: "0px",
                            height: "100%",
                            "line-height": "28px",
                            "padding-right": "5px"
                          },
                          attrs: {
                            "input-align": "right",
                            "label-align": "left",
                            size: "14px",
                            placeholder: "请输入票据税号",
                            "right-icon": "edit"
                          },
                          model: {
                            value: _vm.userInfo.ticketTaxNumber,
                            callback: function($$v) {
                              _vm.$set(_vm.userInfo, "ticketTaxNumber", $$v)
                            },
                            expression: "userInfo.ticketTaxNumber"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "login-btn",
              staticStyle: { padding: "10px 15px 10px 15px" }
            },
            [
              _c(
                "van-button",
                { attrs: { block: "", type: "info" }, on: { click: _vm.save } },
                [_vm._v(" 保 存 ")]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "login-btn",
              staticStyle: { padding: "10px 15px 10px 15px" }
            },
            [
              _c(
                "van-button",
                { attrs: { block: "" }, on: { click: _vm.cancel } },
                [_vm._v(" 重 置 ")]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                padding: "0px 20px 0px 20px",
                color: "red",
                "text-align": "center"
              }
            },
            [
              _vm._v(
                " 注意：该默认票据抬头仅对以后的收费生效，不会更改已经收费的抬头。 "
              )
            ]
          )
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showOpenBank,
            callback: function($$v) {
              _vm.showOpenBank = $$v
            },
            expression: "showOpenBank"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              "value-key": "name",
              columns: _vm.openBanks
            },
            on: {
              confirm: _vm.onOpenConfirm,
              cancel: function($event) {
                _vm.showOpenBank = false
              }
            }
          })
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showManageBank,
            callback: function($$v) {
              _vm.showManageBank = $$v
            },
            expression: "showManageBank"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              "value-key": "name",
              columns: _vm.manageBanks
            },
            on: {
              confirm: _vm.onManageConfirm,
              cancel: function($event) {
                _vm.showManageBank = false
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }